import React from 'react';
import { ThemeProvider } from '@mui/material/styles';

import getTheme from './getTheme';

type ThemeContainerProps = {
  children: React.ReactNode;
};

const theme = getTheme();

export const ThemeContainer = ({ children }: ThemeContainerProps) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
